'use client';

import React from 'react';
import { debounce } from '@benzinga/utils';
import styled from '@benzinga/themetron';
import Hooks from '@benzinga/hooks';

interface TooltipPopoverProps {
  size?: 'sm' | 'md' | 'lg';
  style?: React.CSSProperties;
  tooltipArrowStyle?: { [key: string]: string };
  updateTooltipCoords: () => void;
  children?: React.ReactNode;
  className?: string;
}

const TooltipPopover = React.forwardRef<HTMLDivElement, TooltipPopoverProps>(
  ({ children, className = '', size, style, tooltipArrowStyle, updateTooltipCoords }, ref) => {
    const updateCoords = debounce(updateTooltipCoords, 100);
    Hooks.useEventListener('resize', updateCoords);

    return (
      <StyledTooltipPopover
        className={`tooltip-popover ${size} ${className}`}
        ref={ref}
        style={style}
        tooltipArrowStyle={tooltipArrowStyle}
      >
        {children}
      </StyledTooltipPopover>
    );
  },
);

export default TooltipPopover;

const StyledTooltipPopover = styled.div<{ tooltipArrowStyle?: { [key: string]: string } }>`
  &.tooltip-popover {
    padding: 8px;
    background: #333;
    color: white;
    box-shadow: 2px 2px 3px rgba(0, 0, 0, 0.3);
    text-align: center;
    font-size: ${({ theme }) => theme.fontSize.sm};
    border-radius: ${({ theme }) => theme.borderRadius.md};
    z-index: 999999;
    position: absolute;
    min-width: 100px;
    max-width: 250px;
    transform: translate(0, -100%);
    animation: zoom-in 0.1s ease;

    @keyframes zoom-in {
      0% {
        transform: scale(0, 0);
      }
      100% {
        transform: scale(1, 1);
      }
    }

    &:after {
      content: '';
      position: absolute;
      top: 100%;
      left: 50%;
      margin-left: -5px;
      border-width: 5px;
      border-style: solid;
      border-color: #333 transparent transparent transparent;
      ${({ tooltipArrowStyle }) => tooltipArrowStyle && tooltipArrowStyle};
    }
    &.price-pred-tooltip {
      text-align: left !important;
      ul {
        padding-left: 1em;
        list-style: disc;
        margin-left: 1em;
        margin-bottom: 1em;
        ul {
          list-style: circle;
        }
      }
    }
  }
`;
